import { useEffect, useState } from "react";
import { api, resolveContact } from "@/lib/api";
import { MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/format";

export default function ContactPage() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);
  const { phone, whatsapp, phoneIsDemo, whatsappIsDemo } = resolveContact(s);
  return (
    <div className="cs-container py-10" data-testid="contact-page">
      <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-gray-900">Visit Carz Swag</h1>
      <p className="mt-3 text-gray-600 max-w-xl">We'd love to meet you in person. Drop by the showroom or reach us online.</p>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="rounded-2xl border border-gray-200 p-6 space-y-4 bg-white">
          <Row icon={<MapPin />} label="Address" value={s.address || "Shop No. 09, G.F., Ansal Majestic Tower, Vikaspuri, Delhi – 110018"} />
          <Row icon={<Phone />} label="Phone" value={phone} href={`tel:${phone}`} demo={phoneIsDemo} />
          <Row icon={<Mail />} label="Email" value={s.email || "carzswag@gmail.com"} href={`mailto:${s.email || "carzswag@gmail.com"}`} />
          <Row icon={<Clock />} label="Hours" value={s.business_hours || "Monday – Sunday: 11:00 AM – 7:00 PM"} />
          <div className="pt-3 grid grid-cols-2 gap-2">
            <a href={buildWhatsAppLink(whatsapp, "Hi Carz Swag!")} target="_blank" rel="noreferrer" className="btn-whatsapp relative" data-testid="contact-whatsapp-btn">
              <MessageCircle size={16} /> WhatsApp {whatsappIsDemo && <DemoTag />}
            </a>
            <a href={`tel:${phone}`} className="btn-primary relative" data-testid="contact-call-btn">
              <Phone size={16} /> Call {phoneIsDemo && <DemoTag />}
            </a>
          </div>
          {(phoneIsDemo || whatsappIsDemo) && (
            <p className="text-[11px] text-gray-400 mt-2 leading-snug">
              <strong>DEMO</strong> contact placeholders — admin to set real Carz Swag numbers in Settings before launch.
            </p>
          )}
        </div>
        <div className="rounded-2xl overflow-hidden border border-gray-200">
          <iframe title="map" src={s.map_embed || "https://www.google.com/maps?q=Ansal+Majestic+Tower+Vikaspuri+Delhi&output=embed"} className="w-full h-full min-h-80 border-0" />
        </div>
      </div>
    </div>
  );
}
const Row = ({ icon, label, value, href, demo }) => (
  <div className="flex gap-3">
    <div className="h-10 w-10 rounded-full bg-[#F6E6EB] text-[#940C2C] flex items-center justify-center shrink-0">{icon}</div>
    <div>
      <div className="text-xs uppercase font-bold tracking-wider text-gray-500">{label}</div>
      {href ? <a href={href} className="font-semibold text-gray-900 hover:text-[#940C2C]">{value} {demo && <DemoTag />}</a> : <div className="font-semibold text-gray-900">{value}</div>}
    </div>
  </div>
);
const DemoTag = () => <span className="ml-1 bg-black/15 text-black/70 text-[9px] font-bold uppercase tracking-wider rounded px-1 py-0.5">DEMO</span>;
